module.exports = __webpack_public_path__ + "static/Connor_L_Morris_Resume_[EXTERNAL]_(Jun 2020)-a2888f3a7b493b80e2843719df5b338a.pdf";